import type {
  FieldDeadlineStatus,
  FieldReportListItem,
  FieldReportSituation,
  FieldReportSync,
} from '@/modules/field/types';

const SITUATION_ALIASES: Record<string, FieldReportSituation> = {
  draft: 'draft',
  rascunho: 'draft',
  pending: 'pending',
  pendente: 'pending',
  recused: 'recused',
  recusado: 'recused',
  in_approval: 'in_approval',
  'em aprovação': 'in_approval',
  'em aprovacao': 'in_approval',
  approved: 'approved',
  aprovado: 'approved',
};

function normalizeSituation(
  raw: unknown,
): FieldReportSituation {
  if (typeof raw !== 'string' || raw.trim() === '') {
    return 'pending';
  }

  const key = raw.trim().toLowerCase();

  return SITUATION_ALIASES[key] ?? (key as FieldReportSituation);
}

function normalizeDeadlineStatus(raw: unknown): FieldDeadlineStatus {
  return raw === 'delayed' ? 'delayed' : 'on_time';
}

function normalizeSync(raw: unknown): FieldReportSync {
  return raw === 'synced' ? 'synced' : 'not_synced';
}

/** Garante shape mínimo para cards — evita crash com cache legado. */
export function normalizeFieldReport(
  item: Partial<FieldReportListItem> & { id: number },
): FieldReportListItem {
  const type = (item.type ?? 'rdo').toLowerCase();
  const situation = normalizeSituation(item.situation);
  const sync = normalizeSync(item.sync);

  return {
    id: item.id,
    date: item.date ?? '—',
    reportDateIso: item.reportDateIso ?? '',
    projectId: item.projectId ?? 0,
    clientId: item.clientId ?? null,
    divisionId: item.divisionId ?? null,
    type,
    client: item.client ?? '—',
    division: item.division ?? '—',
    reportType: item.reportType ?? type.toUpperCase(),
    situation,
    deadlineStatus: normalizeDeadlineStatus(item.deadlineStatus),
    title: item.title ?? `${type.toUpperCase()} #${item.id}`,
    progress:
      typeof item.progress === 'number' && !Number.isNaN(item.progress)
        ? item.progress
        : 0,
    sync,
    createdBy: item.createdBy ?? null,
    collaboratorUserIds: Array.isArray(item.collaboratorUserIds)
      ? item.collaboratorUserIds
      : [],
    activityScheduleItemIds: Array.isArray(item.activityScheduleItemIds)
      ? item.activityScheduleItemIds
      : [],
    canEdit: Boolean(item.canEdit),
    canEvaluate: Boolean(item.canEvaluate),
    canSync: item.canSync !== undefined ? Boolean(item.canSync) : sync !== 'synced',
  };
}
